import { mapGetters } from "vuex"

import handles_saving from "./HandlesSaving"
import profile_utilities from "./ProfileUtilities"
import ui_utilities from "./UiUtilities"
import confirms from "./Confirms"

import RecordEditor from "../ui/RecordEditor"

const is_record_editor = {
    mixins: [handles_saving, profile_utilities, ui_utilities, confirms],
    components: {
        RecordEditor
    },
    mounted () {
        this.reload()
    },
    watch: {
        profile_id: "reload",
        $route: "reload"
    },
    methods: {
        grab_record_id () {
            this.record_id = parseInt(this.$route.params.id)
        },
        reload () {
            if(!this.entity) console.error(this.$root.translate("IsRecordEditor has no entity defined."))

            if(this.is_public_page || this.profile_id) {
                this.$store.dispatch("JANITOR", { entities: [this.entity, ...this.relation_ids] })

                this.grab_record_id()

                this.waiting = true
                this.$store.dispatch(
                    "FETCH_RECORD",
                    {
                        entity: this.entity,
                        id: this.record_id,
                        query: {
                            relation_ids: this.relation_ids,
                            fields: this.fields
                        }
                    }
                ).then(() => {
                }).catch(error => {
                    this.$error(error.message)
                }).then(() => {
                    this.waiting = false
                })
            }
        },
        save (value, field) {
            if(this.edited_record) {
                if(this.edited_record[field] !== value) this.edited_record[field] = value
                return this.save_field(this.edited_record[field], field)
            }
            return Promise.resolve()
        },
        confirm_record_delete () {
            this.$confirm({
                type: "error",
                title: "Delete Record",
                message: "Do you really want to delete this record? There is no undo...",
                cancel: "Keep Record",
                ok: "Delete Record",
                then: (confirmed) => {
                    if(confirmed) this.record_delete()
                }
            })
        },
        record_delete () {
            const old_record = this.edited_record
            this.deleting_record = true
            this.$store.dispatch(
                "RECORD_DELETE",
                {
                    entity: this.entity,
                    id: this.record_id
                }
            ).then(record => {
                this.record_deleted(record || old_record)
            }).catch(this.receive_error).then(() => {
                this.deleting_record = false
            })
        },
        record_deleted (record) {
            this.$router.push({ name: `${this.entity}.list` })
        },
        record_restore () {
            this.$store.dispatch(
                "RECORD_RESTORE",
                {
                    entity: this.entity,
                    id: this.record_id
                }
            ).then(record => {
                this.record_restored(record)
            }).catch(this.receive_error)
        },
        record_restored (record) {
            console.log("Record restored", record)
        }
    },
    computed: {
        ...mapGetters(["entity_record"]),
        edited_record () {
            if(!this.entity || !this.record_id) return null
            return this.entity_record(this.entity, this.record_id)
        },
        page_title () {
            const record = this.edited_record
            const entity_name = this.$root.translate(this.entityName, {}, 1)
            if(!record || !record.id) return this.$root.translate(`New ${entity_name}`)
            return record.name || record.title || record.email || entity_name
        },
        can_view_record_data () {
            if(!this.entity) console.error(this.$root.translate("IsRecordEditor has no entity defined."))

            if(!this.profile) return false
            return true
        },
        can_edit_record_data () {
            if(!this.entity) console.error(this.$root.translate("IsRecordEditor has no entity defined."))

            if(!this.profile) return false
            if(this.is_db_admin_active) return true
            let can = true
            if(this.entity === "user") {
                const record = this.edited_record
                can = (record && (record.id === this.profile.id))
            }
            return !!can
        },
        can_delete_data () {
            if(!this.entity) console.error(this.$root.translate("IsRecordEditor has no entity defined."))

            if(!this.profile) return false
            if(this.is_db_admin_active) return true
            return this.profile.role >= this.$root.constants.roles.BIZ_MANAGER.id
        },
        fields () {
            return null
        }
    },
    data () {
        return {
            // NEEDS TO BE OVERRIDEN
            entityName: "record:::records",
            relation_ids: [],
            deleting_record: false
        }
    }
}

export default is_record_editor
